<template>
  <transition name="privacy">
    <div v-if="show" class="privacy-modal">
      <swiper class="content" :options="swiperOption">
        <swiper-slide class="text ">
          <h3 class="text-center">景德镇御窑厂官网及微信小程序用户协议</h3>
          <br />
          <ul>
            <li>
              <h4>1. 导言</h4>
              <br />
              <p class="text-indent-25">
                欢迎您使用景德镇御窑厂软件及相关服务！
              </p>
              <br />
              <p class="text-indent-25">
                景德镇御窑厂软件及相关服务，系指景德镇御窑厂遗址管理处通过合法拥有并运营的、标注名称为“景德镇御窑厂国家考古遗址公园”的官方网站（jdzyuyao.com）以及微信小程序向您提供的产品与服务，包括但不限于发布信息、全景展示、搜索查询等核心功能以及其他功能。《景德镇御窑厂官网及微信小程序用户协议》（以下简称“本协议”）是您与景德镇御窑厂遗址管理处之间就您注册、登录、使用（以下统称“使用”）景德镇御窑厂软件及相关服务所订立的协议。
              </p>
              <br />
              <p class="text-indent-25">
                为了更好地为您提供服务，请您在开始使用景德镇御窑厂软件及相关服务之前，认真阅读并充分理解本协议，特别是涉及免除或者限制责任的条款、权利许可和信息使用的条款、同意开通和使用特殊单项服务的条款、法律适用和争议解决条款等。<span
                  class="underline"
                >
                  其中，免除或者限制责任条款等重要内容将以加粗形式提示您注意，您应重点阅读。</span
                >
                如您未满18周岁，请在法定监护人陪同下仔细阅读并充分理解本协议，并征得法定监护人的同意后使用景德镇御窑厂软件及相关服务。
              </p>
              <br />
              <p class="text-indent-25">
                如您不同意本协议，这将导致我们无法为您提供完整的产品和服务，您也可以选择停止使用。<span
                  class="underline"
                  >如您自主选择同意或使用景德镇御窑厂软件及相关服务，则视为您已充分理解本协议，并同意作为本协议的一方当事人接受本协议以及其他与景德镇御窑厂软件及相关服务相关的协议和规则（包括但不限于《隐私政策》）的约束。</span
                >
              </p>
              <br />
            </li>
            <li>
              <h4>2. 景德镇御窑厂软件及相关服务</h4>
              <br />
              <ul>
                <li class="text-indent-25">
                  2.1
                  您使用景德镇御窑厂软件及相关服务，可以通过预装、景德镇御窑厂遗址管理处已授权的第三方下载等方式获取微信软件，进而关注并使用景德镇御窑厂微信小程序或访问御窑厂（jdzyuyao.com）官方网站。
                  <br /><br />
                </li>
                <li class="text-indent-25">
                  2.2
                  如您不再使用景德镇御窑厂小程序，您也可自行从微信“我的小程序”中移除，或从最近使用列表中删除。
                  <br /><br />
                </li>
                <li class="text-indent-25">
                  2.3
                  为保证景德镇御窑厂软件及相关服务安全、提升用户服务，在景德镇御窑厂软件及相关服务出现重大更新后，软件平台将以妥当的方式（如网站公告）提示您，您有权选择继续使用或不再使用。
                  <br /><br />
                </li>
                <li class="text-indent-25">
                  2.4
                  除非得到景德镇御窑厂遗址管理处事先书面授权，您不得以任何形式对景德镇御窑厂软件及相关服务进行包括但不限于改编、复制、传播、镜像等未经授权的访问或使用。
                  <br /><br />
                </li>
                <li class="text-indent-25">
                  2.5使用景德镇御窑厂软件及相关服务需自行准备与软件及相关服务有关的终端设备（如电脑、手机等），一旦您在终端设备中打开景德镇御窑厂小程序或访问“jdzyuyao.com”网站，即视为您使用景德镇御窑厂软件及相关服务。为充分实现景德镇御窑厂软件的全部功能，您需要将终端设备联网，并由您自行承担所需要的费用（如流量费、上网费等）。
                  <br /><br />
                </li>
                <li class="text-indent-25">
                  2.6
                  您无需注册也可开始使用景德镇御窑厂软件及相关服务，但部分功能或服务可能会受到影响。
                  <br /><br />
                </li>
              </ul>
            </li>
            <li>
              <h4>3. 关于账号</h4>
              <br />
              <ul>
                <li class="text-indent-25">
                  3.1
                  您需要理解，您所使用的景德镇御窑厂账号是通过微信扫码完成账号注册并进行登录的。如果您有多个微信账号，可能会在登录并使用御窑厂软件服务时，出现您所认为的账号数据不一致或错误，而产生的原因实际是因为您使用了不同的微信账号进行登录并使用景德镇御窑厂软件提供的服务。
                  <br /><br />
                </li>
                <li class="text-indent-25 underline">
                  3.2
                  您的账号仅限于您本人使用，未经景德镇御窑厂遗址管理处书面同意，禁止以任何形式赠与、借用、出租、转让、售卖或以其他方式许可他人使用该账号。如果景德镇御窑厂遗址管理处发现或者有合理理由认为使用者并非账号初始注册人，为保障账号安全，景德镇御窑厂遗址管理处有权立即暂停或终止向该注册账号提供服务，或注销该账号。
                  <br /><br />
                </li>
              </ul>
            </li>
            <li>
              <h4>4. 用户个人信息保护</h4>
              <br />
              <ul>
                <li class="text-indent-25">
                  景德镇御窑厂遗址管理处与您一同致力于您个人信息的保护，保护用户个人信息是景德镇御窑厂遗址管理处的基本原则之一。在使用景德镇御窑厂软件及相关服务的过程中，您可能需要提供您的个人信息（包括但不限于姓名、电话号码、位置信息等），以便景德镇御窑厂遗址管理处向您提供更好的服务和相应的技术支持。景德镇御窑厂遗址管理处将运用加密技术、匿名化处理等其他与景德镇御窑厂软件及相关服务相匹配的技术措施及其他安全措施保护您的个人信息，更多关于用户个人信息保护的内容，请参见《隐私政策》。
                  <br /><br />
                </li>
              </ul>
            </li>
            <li>
              <h4>5. 用户行为规范</h4>
              <br />
              <ul>
                <li>
                  <h5 class="text-indent-25">5.1 用户行为要求</h5>
                  <br />
                  <p class="text-indent-25">
                    您应当对您使用本软件及相关服务的行为负责，除非法律允许或者经景德镇御窑厂遗址管理处事先书面许可，您使用景德镇御窑厂软件及相关服务不得具有下列行为：
                  </p>
                  <br />
                  <ul>
                    <li class="text-indent-25 underline">
                      5.1.1
                      使用未经景德镇御窑厂遗址管理处授权或许可的任何插件、外挂、系统或第三方工具对景德镇御窑厂软件及相关服务的正常运行进行干扰、破坏、修改或施加其他影响。
                      <br />
                    </li>
                    <li class="text-indent-25 ">
                      <br />
                      <p class="underline">
                        5.1.2
                        利用或针对景德镇御窑厂软件及相关服务进行任何危害计算机网络安全的行为，包括但不限于：
                      </p>
                      <br />
                      <ol>
                        <li class="text-indent-25">
                          （1）非法侵入他人网络、干扰他人网络正常功能、窃取网络数据等危害网络安全的活动；
                          <br /><br />
                        </li>
                        <li class="text-indent-25">
                          （2）提供专门用于从事侵入网络、干扰网络正常功能及防护措施、窃取网络数据等危害网络安全活动的程序、工具；
                          <br /><br />
                        </li>
                        <li class="text-indent-25">
                          （3）明知他人从事危害网络安全的活动，为其提供技术支持、广告推广、支付结算等帮助；
                          <br /><br />
                        </li>
                        <li class="text-indent-25">
                          （4）使用未经许可的数据或进入未经许可的服务器/账号；
                          <br /><br />
                        </li>
                        <li class="text-indent-25">
                          （5）未经允许进入公众计算机网络或者他人计算机系统并删除、修改、增加存储信息；
                          <br /><br />
                        </li>
                        <li class="text-indent-25">
                          （6）未经许可，企图探查、扫描、测试景德镇御窑厂系统或网络的弱点或其它实施破坏网络安全的行为；
                          <br /><br />
                        </li>
                        <li class="text-indent-25">
                          （7）企图干涉、破坏景德镇御窑厂系统或网站的正常运行，故意传播恶意程序或病毒以及其他破坏干扰正常网络信息服务的行为；
                          <br /><br />
                        </li>
                        <li class="text-indent-25">
                          （8）伪造TCP/IP数据包名称或部分名称； <br /><br />
                        </li>
                        <li class="text-indent-25">
                          （9）
                          对景德镇御窑厂软件及相关服务进行反向工程、反向汇编、编译或者以其他方式尝试发现本软件的源代码；
                          <br /><br />
                        </li>
                        <li class="text-indent-25">
                          （10）
                          恶意注册景德镇御窑厂软件及相关服务的账号，包括但不限于频繁、批量注册账号；
                          <br /><br />
                        </li>
                        <li class="text-indent-25">
                          （11）
                          违反法律法规、本协议、景德镇御窑厂遗址管理处的相关规则及侵犯他人合法权益的其他行为。
                          <br /><br />
                        </li>
                      </ol>
                    </li>
                    <li class="text-indent-25 underline">
                      5.1.3
                      如果景德镇御窑厂遗址管理处有理由认为您的行为违反或可能违反上述约定的，景德镇御窑厂遗址管理处可独立进行判断并处理，且有权在不事先通知的情况下终止向您提供服务，并追究相关法律责任。
                      <br />
                    </li>
                    <li class="text-indent-25">
                      <br />
                      <p class="underline">
                        5.1.4
                        您评论、发布、传播的内容应自觉遵守宪法法律、法规、遵守公共秩序，尊重社会公德、社会主义制度、国家利益、公民合法权益、道德风尚和信息真实性等要求。您同意并承诺不制作、复制、发布、传播法律、法规禁止的下列信息内容：
                      </p>
                      <br />
                      <ol>
                        <li class="text-indent-25">
                          （1）反对宪法确定的基本原则的； <br /><br />
                        </li>
                        <li class="text-indent-25">
                          （2）危害国家安全、泄露国家秘密的； <br /><br />
                        </li>
                        <li class="text-indent-25">
                          （3）颠覆国家政权、推翻社会主义制度、煽动分裂国家、破坏国家统一的；
                          <br /><br />
                        </li>
                        <li class="text-indent-25">
                          （4）损害国家荣誉和利益的； <br /><br />
                        </li>
                        <li class="text-indent-25">
                          （5）宣扬恐怖主义、极端主义的； <br /><br />
                        </li>
                        <li class="text-indent-25">
                          （6）宣扬民族仇恨、民族歧视、破坏民族团结的；
                          <br /><br />
                        </li>
                        <li class="text-indent-25">
                          （7）煽动地域歧视、地域仇恨的； <br /><br />
                        </li>
                        <li class="text-indent-25">
                          （8）破坏国家宗教政策，宣扬邪教和迷信的； <br /><br />
                        </li>
                        <li class="text-indent-25">
                          （9）编造、散布谣言、虚假信息，扰乱经济秩序和社会秩序、破坏社会稳定的；
                          <br /><br />
                        </li>
                        <li class="text-indent-25">
                          （10）散布、传播暴力、淫秽、色情、赌博、凶杀、恐怖或者教唆犯罪的；
                          <br /><br />
                        </li>
                        <li class="text-indent-25">
                          （11）侵害未成年人合法权益或者损害未成年人身心健康的；<br /><br />
                        </li>
                        <li class="text-indent-25">
                          （12）未获他人允许，偷拍、偷录他人，侵害他人合法权利的；<br /><br />
                        </li>
                        <li class="text-indent-25">
                          （13）包含恐怖、暴力血腥、高危险性、危害表演者自身或他人身心健康内容的；<br /><br />
                        </li>
                        <li class="text-indent-25">
                          （14）危害网络安全、利用网络从事危害国家安全、荣誉和利益的；<br /><br />
                        </li>
                        <li class="text-indent-25">
                          （15）侮辱或者诽谤他人，侵害他人合法权益的；<br /><br />
                        </li>
                        <li class="text-indent-25">
                          （16）对他人进行暴力恐吓、威胁，实施人肉搜索的；<br /><br />
                        </li>
                        <li class="text-indent-25">
                          （17）涉及他人隐私、个人信息或资料的；<br /><br />
                        </li>
                        <li class="text-indent-25">
                          （18）散布污言秽语，损害社会公序良俗的；<br /><br />
                        </li>
                        <li class="text-indent-25">
                          （19）侵犯他人隐私权、名誉权、肖像权、知识产权等合法权益内容的；<br /><br />
                        </li>
                        <li class="text-indent-25">
                          （20）散布商业广告，或类似的商业招揽信息、过度营销信息及垃圾信息；<br /><br />
                        </li>
                        <li class="text-indent-25">
                          （21）使用本网站常用语言文字以外的其他语言文字评论的；<br /><br />
                        </li>
                        <li class="text-indent-25">
                          （22）与所评论的信息毫无关系的；<br /><br />
                        </li>
                        <li class="text-indent-25">
                          （23）所发表的信息毫无意义的，或刻意使用字符组合以逃避技术审核的；<br /><br />
                        </li>
                        <li class="text-indent-25">
                          （24）其他违反法律法规、政策及公序良俗、干扰景德镇御窑厂正常运营或侵犯其他用户或第三方合法权益内容的其他信息。
                          <br /><br />
                        </li>
                      </ol>
                    </li>
                  </ul>
                </li>
                <li>
                  <h5 class="text-indent-25">5.2</h5>
                  <p class="text-indent-25">
                    景德镇御窑厂官网设立政府网站纠错链接，您可提交认为网站上有错误或表述不准确的内容，网站工作人员得到相关通知后将及时受理和处理您的反馈意见。
                  </p>
                  <br />
                </li>
              </ul>
            </li>
            <li>
              <h4>6. 景德镇御窑厂信息内容的使用规范</h4>
              <br />
              <ul>
                <li>
                  <p class="text-indent-25">
                    6.1
                    未经景德镇御窑厂遗址管理处书面许可，您不得自行或授权、允许、协助任何第三人对景德镇御窑厂软件及相关服务中信息内容进行如下行为：
                  </p>
                  <br />
                  <ol>
                    <li class="text-indent-25">
                      （1）复制、读取、采用景德镇御窑厂软件及相关服务的信息内容，用于包括但不限于宣传、增加阅读量、浏览量等商业用途；
                      <br /><br />
                    </li>
                    <li class="text-indent-25">
                      （2）擅自编辑、整理、编排景德镇御窑厂软件及相关服务的信息内容后在景德镇御窑厂软件及相关服务的源页面以外的渠道进行展示；
                      <br /><br />
                    </li>
                    <li class="text-indent-25">
                      （3）其他非法获取或使用景德镇御窑厂软件及相关服务的信息内容的行为。
                      <br /><br />
                    </li>
                  </ol>
                </li>
                <li>
                  <p class="text-indent-25">
                    6.2
                    经景德镇御窑厂遗址管理处书面许可后，您对景德镇御窑厂软件及相关服务的信息内容的分享、转发等行为，还应符合以下规范：
                  </p>
                  <br />
                  <ol>
                    <li class="text-indent-25">
                      （1）应当采取安全、有效、严密的措施，防止景德镇御窑厂软件及相关服务的信息内容被第三方通过包括但不限于“蜘蛛（spider）”程序等任何形式进行非法获取；
                      <br /><br />
                    </li>
                    <li class="text-indent-25">
                      （2）不得把相关数据内容用于景德镇御窑厂遗址管理处书面许可范围之外的目的，进行任何形式的销售和商业使用，或向第三方泄露、提供或允许第三方为任何方式的使用；
                      <br /><br />
                    </li>
                    <li class="text-indent-25">
                      （3）向任何第三人分享、转发、复制景德镇御窑厂软件及相关服务信息内容的行为，应当遵守景德镇御窑厂遗址管理处为此制定的其他规范和标准。
                      <br /><br />
                    </li>
                  </ol>
                </li>
              </ul>
            </li>
            <li>
              <h4>7. 服务的变更、中断和终止</h4>
              <br />
              <ul>
                <li class="text-indent-25">
                  7.1
                  您理解并同意，景德镇御窑厂遗址管理处提供的软件及相关服务是按照现有技术和条件所能达到的现状提供的。景德镇御窑厂遗址管理处会尽最大努力向您提供服务，确保服务的连贯性和安全性。您理解，景德镇御窑厂遗址管理处不能随时预见和防范技术以及其他风险，包括但不限于不可抗力、网络原因、第三方服务瑕疵、第三方网站等原因可能导致的服务中断、不能正常使用本软件及服务以及其他的损失和风险。
                  <br /><br />
                </li>
                <li class="text-indent-25">
                  7.2
                  您理解并同意，景德镇御窑厂遗址管理处为了服务整体运营、平台运营安全的需要，有权视具体情况有权决定服务/功能设置、范围，修改、中断、中止或终止景德镇御窑厂软件及相关服务。
                  <br /><br />
                </li>
              </ul>
            </li>
            <li>
              <h4>8. 知识产权</h4>
              <br />
              <ul>
                <li class="text-indent-25">
                  8.1
                  景德镇御窑厂遗址管理处在景德镇御窑厂软件及相关服务中提供的内容（包括但不限于软件、技术、程序、网页、文字、图片、图像、音频、视频、图表、版面设计、电子文档等）的知识产权属于景德镇御窑厂遗址管理处所有。景德镇御窑厂遗址管理处提供本服务时所依托的软件的著作权、专利权及其他知识产权均归景德镇御窑厂遗址管理处所有。未经景德镇御窑厂遗址管理处许可，任何人不得擅自使用（包括但不限于通过任何机器人、蜘蛛等程序或设备监视、复制、传播、展示、镜像、上载、下载）景德镇御窑厂软件及相关服务中的内容。
                  <br /><br />
                </li>
                <li class="text-indent-25">
                  8.2
                  景德镇御窑厂遗址管理处对景德镇御窑厂官网和小程序的开发和运营等过程中产生的所有数据和信息等享有法律法规允许范围内的全部权利。
                  <br /><br />
                </li>
                <li class="text-indent-25 underline">
                  8.3
                  请您在任何情况下都不要私自使用景德镇御窑厂遗址管理处的包括但不限于“御窑厂”、景德镇御窑厂和“jdzyuyao.com”等在内的任何商标、服务标记、商号、域名、网站名称或其他显著品牌特征等（以下统称为“标识”）。未经景德镇御窑厂遗址管理处事先书面同意，您不得将本条款前述标识以单独或结合任何方式展示、使用或申请注册商标、进行域名注册等，也不得实施向他人明示或暗示有权展示、使用、或其他有权处理该些标识的行为。由于您违反本协议使用景德镇御窑厂遗址管理处上述商标、标识等给景德镇御窑厂遗址管理处或他人造成损失的，由您承担全部法律责任。
                  <br /><br />
                </li>
              </ul>
            </li>
            <li>
              <h4>9. 免责声明</h4>
              <br />
              <ul class="underline">
                <li class="text-indent-25">
                  9.1
                  您理解并同意，景德镇御窑厂软件及相关服务可能会受多种因素的影响或干扰，景德镇御窑厂遗址管理处不保证(包括但不限于)：
                  <br /><br />
                  <ul>
                    <li>
                      9.1.1
                      景德镇御窑厂软件及相关服务完全适合用户的所有使用要求；<br /><br />
                    </li>
                    <li>
                      9.1.2
                      景德镇御窑厂软件及相关服务不受干扰，及时、安全、可靠或不出现任何错误；<br /><br />
                    </li>
                    <li>
                      9.1.3
                      景德镇御窑厂软件及相关服务中任何错误都将能得到更正。<br /><br />
                    </li>
                  </ul>
                </li>
                <li class="text-indent-25">
                  9.2
                  如有涉嫌借款或其他涉及财产的网络信息、账户密码、广告或推广等信息，请您谨慎对待并自行进行判断，您因此遭受的利润、商业信誉、资料损失或其他有形或无形损失，景德镇御窑厂遗址管理处不承担任何直接、间接、附带、特别、衍生性或惩罚性的赔偿责任。
                  <br /><br />
                </li>
                <li class="text-indent-25">
                  9.3
                  您理解并同意，在使用景德镇御窑厂软件及相关服务过程中，可能遇到不可抗力等因素（不可抗力是指不能预见、不能克服并不能避免的客观事件），包括但不限于自然灾害(如洪水、地震、台风等)、政府行为、战争、罢工、骚动、暴乱等。出现不可抗力情况时，景德镇御窑厂遗址管理处将努力在第一时间及时修复，但因不可抗力造成的损失，景德镇御窑厂遗址管理处在法律法规范围内免于承担责任。
                  <br /><br />
                </li>
                <li class="text-indent-25">
                  9.4
                  您理解并同意，关于景德镇御窑厂软件及相关服务，景德镇御窑厂遗址管理处不提供任何种类的明示或暗示担保或条件，包括但不限于商业适售性、特定用途适用性等。您对景德镇御窑厂软件及相关服务的使用行为需自行承担相应风险。
                  <br /><br />
                </li>
                <li class="text-indent-25">
                  9.5
                  您理解并同意，本协议是在保障遵守国家法律法规、维护公序良俗，保护他人合法权益，景德镇御窑厂遗址管理处在能力范围内尽最大的努力按照相关法律法规进行判断，但并不保证景德镇御窑厂遗址管理处判断完全与司法机关、行政机关的判断一致，如因此产生的后果您已经理解并同意自行承担。
                  <br /><br />
                </li>
                <li class="text-indent-25">
                  9.6
                  在任何情况下，景德镇御窑厂遗址管理处均不对任何间接性、后果性、惩罚性、偶然性、特殊性或刑罚性的损害，包括因您使用景德镇御窑厂软件及相关服务而遭受的利润损失，承担责任。景德镇御窑厂遗址管理处对您承担的全部责任，无论因何原因或何种行为方式，始终不超过您在成员期内因使用景德镇御窑厂软件及相关服务而支付给景德镇御窑厂遗址管理处的费用(如有)。
                  <br /><br />
                </li>
              </ul>
            </li>
            <li>
              <h4>10. 关于单项服务与第三方服务的特殊约定</h4>
              <br />
              <p class="text-indent-25 underline">
                如您在景德镇御窑厂软件中使用第三方提供的软件或相关服务时（如微信第三方登录功能），除遵守本协议及景德镇御窑厂相关规则外，还可能需要同意并遵守第三方的协议、隐私政策及相关规则。如因第三方软件及相关服务产生的争议、损失或损害，由您与第三方自行解决，景德镇御窑厂遗址管理处并不就此而对您或任何第三方承担任何责任。
              </p>
              <br />
            </li>
            <li>
              <h4>11. 未成年人使用条款</h4>
              <br />
              <ul class="underline">
                <li class="text-indent-25">
                  11.1
                  若用户是未满18周岁的未成年人，应在监护人监护、指导并获得监护人同意情况下认真阅读本协议后，方可使用景德镇御窑厂软件及相关服务。
                  <br /><br />
                </li>
                <li class="text-indent-25">
                  11.2
                  景德镇御窑厂遗址管理处重视对未成年人个人信息的保护，未成年用户在填写个人信息时，请加强个人保护意识并谨慎对待，并在监护人指导时正确使用景德镇御窑厂软件及相关服务。
                  <br /><br />
                </li>
                <li class="text-indent-25">
                  11.3
                  未成年用户理解如因您违反法律法规、本协议内容，则您及您的监护人应依照法律规定承担因此而可能引起的全部法律责任。
                  <br /><br />
                </li>
              </ul>
            </li>
            <li>
              <h4>12. 其他</h4>
              <br />
              <ul class="underline">
                <li class="text-indent-25">
                  12.1
                  本协议的成立、生效、履行、解释及争议的解决均应适用中华人民共和国法律。若本协议之任何规定因与中华人民共和国的法律抵触而无效或不可执行，则这些条款将尽可能按照接近本协议原条文意旨重新解析，且本协议其它规定仍应具有完整的效力及效果。
                  <br /><br />
                </li>
                <li class="text-indent-25">
                  12.2
                  本协议的签订地为中华人民共和国江西省景德镇市珠山区。若您因本协议与景德镇御窑厂遗址管理处发生任何争议，双方应尽量友好协商解决；如协商不成的，您同意应将相关争议提交至本协议签订地的人民法院诉讼解决。
                  <br /><br />
                </li>
                <li class="text-indent-25">
                  12.3
                  为给您提供更好的服务或国家法律法规、政策调整，景德镇御窑厂及相关服务将不时更新与变化，我们会适时对本协议进行修订，这些修订构成本协议的一部分。本协议更新后，我们会在景德镇御窑厂软件中发出更新版本，并在更新后的条款生效前通过官方网站（www.jdzyuyao.com）公告或其他适当的方式提醒您更新的内容，以便您及时了解本协议的最新版本，您也可以在网站首页或软件设置页面查阅最新版本的协议条款。如您继续使用景德镇御窑厂软件及相关服务，表示同意接受修订后的本协议的内容。
                  <br /><br />
                </li>
                <li class="text-indent-25">
                  如您对修改后的协议条款存有异议的，请立即停止登录或使用景德镇御窑厂软件及相关服务。若您继续登录或使用景德镇御窑厂软件及相关服务，即视为您认可并接受修改后的协议条款。
                  <br /><br />
                </li>
              </ul>
            </li>
          </ul>
        </swiper-slide>
        <div class="swiper-scrollbar" slot="scrollbar"></div>
      </swiper>
      <div class="modal-close" @click="$emit('update:show', false)"></div>
    </div>
  </transition>
</template>
<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
export default {
  name: 'privacy',
  props: {
    show: null
  },
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      swiperOption: {
        direction: 'vertical',
        slidesPerView: 'auto',
        freeMode: true,
        scrollbar: {
          el: '.swiper-scrollbar'
        },
        mousewheel: true
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/css_base.scss';
.privacy-enter-active,
.privacy-leave-active {
  transition: opacity 0.35s;
  -moz-transition: opacity 0.35s;
  /* Firefox 4 */
  -webkit-transition: opacity 0.35s;
  /* Safari 和 Chrome */
  -o-transition: opacity 0.35s;
  /* Opera */
}

.privacy-enter,
.privacy-leave-to {
  opacity: 0;
}
</style>
